import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import AdmissionContext from "../AdmissionContext";
import QRCode from "qrcode.react";
import Grid from "@material-ui/core/Grid";
import { kPButton } from "../global";

class SuccessView extends Component {
  static contextType = AdmissionContext;

  render() {
    return (
      <Box display="flex" justifyContent="center" pt={2}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
            <Card
              style={{
                border: 0,
                // minWidth: 500,
                // maxWidth: 600,
              }}
              variant="outlined"
            >
              <CardContent>
                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={22}
                    color="#388e3c"
                    display="flex"
                    justifyContent="center"
                  >
                    SUCCESSFUL
                  </Box>
                </Typography>

                <Typography component="div">
                  <Box
                    fontSize={16}
                    color="#808080"
                    display="flex"
                    justifyContent="center"
                    pt={2}
                  >
                    Please save your admision reference number.
                  </Box>
                </Typography>

                <Box display="flex" justifyContent="center" pt={2}>
                  <QRCode value={this.context.ano} />,
                </Box>

                <Typography component="div">
                  <Box
                    fontSize={18}
                    color="#808080"
                    display="flex"
                    justifyContent="center"
                    pt={2}
                  >
                    {this.context.ano}
                  </Box>
                </Typography>

                {/* BUTTON         */}
                <Box
                  justifyContent="center"
                  display="flex"
                  pt={4}
                  fontSize={14}
                >
                  <Box width={200} justifyContent="center">
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.context.initState();
                      }}
                    >
                      CLOSE
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={1} sm={2} lg={3}></Grid>
        </Grid>
      </Box>
    );
  }
}

export default SuccessView;
